<script>
import NavBar from "./NavBar.vue";

export default {
  name: "frontend",
  components: {NavBar}
}
</script>

<template>
  <NavBar></NavBar>
  <div class="flex justify-center pb-36 h-100vh w-full">
    <slot/>
  </div>
</template>